/* eslint-disable no-unused-vars */
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator, collection } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

// Helper function to clean environment variables (remove leading "=" if present)
const cleanEnvVar = (value) => {
  if (typeof value === 'string' && value.startsWith('=')) {
    return value.substring(1);
  }
  return value;
};

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: cleanEnvVar(process.env.REACT_APP_FIREBASE_API_KEY),
  authDomain: cleanEnvVar(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN),
  projectId: cleanEnvVar(process.env.REACT_APP_FIREBASE_PROJECT_ID),
  storageBucket: cleanEnvVar(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: cleanEnvVar(process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID),
  appId: cleanEnvVar(process.env.REACT_APP_FIREBASE_APP_ID),
  measurementId: cleanEnvVar(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID),
  databaseURL: cleanEnvVar(process.env.REACT_APP_FIREBASE_DATABASE_URL)
};

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app, "us-central1");
const auth = getAuth(app);
const db = getFirestore(app);
const realtimeDb = getDatabase(app);
const storage = getStorage(app);

// Collection References
export const receiptsCollection = collection(db, "receipts");

export { app, db, functions, auth, realtimeDb, storage };
